"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20Node = exports.Z20Graph = void 0;
class Z20Graph {
    constructor() {
        this.nodesMap = new Map();
        this.nodesList = [];
    }
    addConnection(from, to) {
        const fromNode = this.ensureNode(from);
        const toNode = this.ensureNode(to);
        // console.log(`Connecting ${from} to ${to}`);
        fromNode.addConnection(toNode);
        toNode.addConnection(fromNode);
    }
    removeConnection(from, to) {
        const fromNode = this.tryGetNode(from);
        const toNode = this.tryGetNode(to);
        if (fromNode && toNode) {
            fromNode.removeConnection(toNode);
            toNode.removeConnection(fromNode);
        }
    }
    getNode(t) {
        return this.nodesMap.get(t.id);
    }
    tryGetNode(t) {
        return this.nodesMap.get(t.id);
    }
    ensureNode(t) {
        let node = this.nodesMap.get(t.id);
        if (node === undefined) {
            node = new Z20Node(t);
            this.nodesMap.set(t.id, node);
            this.nodesList.push(node);
        }
        return node;
    }
    removeNode(t) {
        let node = this.nodesMap.get(t.id);
        if (t) {
            for (const neighbor of node.neighbors) {
                neighbor.removeConnection(node);
                node.removeConnection(neighbor);
            }
            this.nodesList = this.nodesList.filter(x => x !== node);
            this.nodesMap.delete(node.thing.id);
        }
    }
    terminalNodes() {
        const terminalNodes = [];
        for (const node of this.nodesList) {
            if (node.terminal())
                terminalNodes.push(node);
        }
        return terminalNodes;
    }
}
exports.Z20Graph = Z20Graph;
class Z20Node {
    terminal() {
        return this.connections.size == 1;
    }
    constructor(thing) {
        this.thing = thing;
        this.connections = new Map();
        this.neighbors = [];
    }
    addConnection(other) {
        if (!this.connections.has(other.thing.id)) {
            this.connections.set(other.thing.id, other);
            this.neighbors.push(other);
        }
    }
    removeConnection(other) {
        if (this.connections.has(other.thing.id)) {
            this.connections.delete(other.thing.id);
            this.neighbors = this.neighbors.filter(x => x !== other);
        }
    }
}
exports.Z20Node = Z20Node;
